import { Link, NavLink } from 'react-router-dom'

interface LandingNavProps {
  /** Pages other than the landing page have no #pricing section to scroll to. */
  pricingHref?: string
}

/** The logo mark stands alone: it has no text lockup anywhere in the product. */
export function LandingNav({ pricingHref = '#pricing' }: LandingNavProps) {
  return (
    <header className="absolute inset-x-0 top-0 z-20 text-carbonBlack">
      <div className="l-frame l-small flex h-[72px] items-center justify-between gap-6 font-medium">
        <Link to="/" aria-label="SitRepp home" className="shrink-0">
          <img src="/favicon.png" alt="" className="h-9 w-auto" />
        </Link>

        <nav aria-label="Main" className="flex items-center gap-6">
          {pricingHref.startsWith('#') ? (
            <a href={pricingHref} className="l-link hidden sm:inline">
              Pricing
            </a>
          ) : (
            <Link to={pricingHref} className="l-link hidden sm:inline">
              Pricing
            </Link>
          )}
          <NavLink to="/about" className="l-link hidden sm:inline">
            About
          </NavLink>
          <Link to="/login" className="l-link">
            Sign in
          </Link>
        </nav>
      </div>
    </header>
  )
}
